import { IMemberModel } from 'models';
import React, { useState } from 'react';

import styles from './member-card.module.scss';

type Props = {
  member: IMemberModel;
};

export default function MemberCard({ member }: Props) {
  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);

  if (!member) return <></>;

  return (
    <div
      className={styles.container}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      style={{ backgroundImage: `url(${member.photoUrl})` }}>
      <div className={styles['image-caption']}>
        {!member.published && <div className={styles['draft']}>Brouillon</div>}
        {member.lastname} {member.firstname}
        <div className={styles.title}>
          {member.title && <>{member.title}</>}
        </div>
      </div>
      <div
        className={
          hovered ? styles['image-overlay-hover'] : styles['image-overlay']
        }></div>
    </div>
  );
}
